import React, { useEffect, useState } from "react";
import "./../../src/theme.scss";
import "../assets/styles/common-styles.scss";
import FormLayout from "./FormLayout";
import ResetPassword from "../components/ForgotPassword/ResetPassword";
import GetPasscode from "../components/ForgotPassword/GetPasscode";
import { useLocation } from "react-router-dom";

const ForgotPassword: React.FunctionComponent<any> = () => {
  const [isEmailPresent, setIsEmailPresent] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    const checkEmailPresence = () => {
      setIsEmailPresent(!!localStorage.getItem("passcodeEmail"));
    };
    checkEmailPresence();
    window.addEventListener("storage", checkEmailPresence);
    return () => {
      window.removeEventListener("storage", checkEmailPresence);
    };
  }, []);

  useEffect(() => {
    return () => {
      localStorage.removeItem("passcodeEmail");
      localStorage.removeItem("passcodeStartTime");
    };
  }, [location?.pathname]);

  return (
    <FormLayout title="Reset Your Password">
      {isEmailPresent ? (
        <ResetPassword
          isEmailPresent={isEmailPresent}
          setIsEmailPresent={setIsEmailPresent}
        />
      ) : (
        <GetPasscode
          isEmailPresent={isEmailPresent}
          setIsEmailPresent={setIsEmailPresent}
        />
      )}
    </FormLayout>
  );
};

export default ForgotPassword;
